document.addEventListener('DOMContentLoaded', () => {

    var $Products = $('.manual-product')
    var $ManualPages = $('div#download-page');
    var $ManualGrids = $ManualPages.find('> .grid');

    function mergeManualProductGrids() {
        if ($ManualGrids.length <= 1) return;

        var $PrimaryGrid = $ManualGrids.first();
        $ManualGrids.slice(1).each(function () {
            var $Grid = $(this);
            $Grid.children('.shopify-block').appendTo($PrimaryGrid);
            $Grid.closest('div#download-page').addClass('download-page--merged-hidden');
        });
    }

    mergeManualProductGrids();
    $Products = $('.manual-product');

    function syncDownloadManualsTiles() {
        var type = $('#se-pro-type').val();
        $('.download-manuals-nav__tile').each(function () {
            var $t = $(this);
            var active = $t.attr('data-filter-value') === type;
            $t.toggleClass('is-active', active);
            $t.attr('aria-pressed', active ? 'true' : 'false');
        });
    }

    // type 选择功能
    $('#se-pro-type').change(function () {
        let type = $(this).val();

        if (type == 'ALL') {
            $Products.parents('.shopify-block').show()
        } else {
            $Products.each(function () {
                var $this = $(this)
                var value = $this.attr('value')
                var $Parent = $this.parents('.shopify-block')
    
                if (type == value) {
                    $Parent.show()
                } else {
                    $Parent.hide()
                }
            })
        }

        manualpageSearch()
        SearchText()
        syncDownloadManualsTiles()
    });

    $(document).on('click', '.download-manuals-nav__tile', function () {
        var v = $(this).attr('data-filter-value');
        if (v === undefined) return;
        $('#se-pro-type').val(v).trigger('change');
    });


    // 搜索功能
    var $SearchInput = $("#dowload_search input");
    var $NotSearch = $(".not-search");
    
    function manualpageSearch() {
        var result = $SearchInput.val().toLowerCase();
        var type = $('#se-pro-type').val()

        if (type == "ALL") {
            var $ShowProduct = $Products;
        } else {
            var $ShowProduct = $(`.manual-product[value="${type}"]`);
        }

        $ShowProduct.each(function () {
            var $this = $(this);
            var $Parent = $this.parents('.shopify-block')
            var title = $this.find(".grid-view-item__title").text().toLowerCase();

            if (title.includes(result)) {
                $Parent.show();
            } else {
                $Parent.hide();
            }
        })
    }

    function SearchText() {
        var allHidden = true;
        $Products.each(function () {
          var $this = $(this).parents('.shopify-block');
          if ($this.css("display") !== "none") {
            allHidden = false;
            return false;
          }
        });
    
        if (allHidden) {
          $NotSearch.show();
        } else {
          $NotSearch.hide();
        }
      }

    $(' #searchstr').keypress(function (e) {
        if (e.which == 13) {
            manualpageSearch();
            SearchText()
        }
    });
    
    $('.bt_manual').click(function () {
        manualpageSearch();
        SearchText()
    });



    $('#download-page .grid-view-item').click(function () {
        $(this).addClass('active');
    });

    $('#download-page .grid-view-item.active .download-dialog').click(function (e) {
        e.stopPropagation()
    })

    $('#download-page .download-main .close_btn').click(function (e) {
        e.stopPropagation();
        $(this).closest('.grid-view-item').removeClass('active');
    });

    syncDownloadManualsTiles()
});